/**
 * Wineemotion brand logo. Usa il PNG /brand/wineemotion-logo.png.
 * Props:
 * - size: sm (h-4), md (h-5), lg (h-6), xl (h-10), 2xl (h-16)
 * - variant: "on-brand" (per sfondi rossi Wineemotion — usa versione bianca) o "default"
 * - className: aggiuntive classi
 */
export function BrandLogo({ size = "md", className = "", alt = "Wineemotion" }) {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
    xl: "h-10 w-10",
    "2xl": "h-16 w-16",
  };
  return (
    <img
      src="/brand/wineemotion-logo.png"
      alt={alt}
      className={`${sizes[size] || sizes.md} object-contain ${className}`}
      draggable={false}
    />
  );
}
